import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function AppLayout() {
  return (
    <div data-testid="app-layout" className="flex h-screen bg-background">
      <Sidebar />
      <main className="flex-1 overflow-y-auto max-w-[calc(100vw-236px)] mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
